import { render } from "./VehicleFilms.vue?vue&type=template&id=272a88c9"
import script from "./VehicleFilms.vue?vue&type=script&lang=js"
export * from "./VehicleFilms.vue?vue&type=script&lang=js"

import exportComponent from "/Users/fanhaipeng/code/giga-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__